import barba from '@barba/core';

const inputLabelAnimation = (container) => {

	const inputFields = container.querySelectorAll(
		".ginput_container_text, .ginput_container_phone, .ginput_container_email, .ginput_container_textarea, .ginput_container_number"
	);

	const selectFields = container.querySelectorAll(
		".ginput_container_select, .ginput_container_date, g "
	);

	if (selectFields.length > 0) {
		selectFields.forEach((e) => {
			e.parentNode
				.querySelector(".gfield_label")
				.classList.add("filled");
		});
	}

	if (inputFields.length > 0) {
		inputFields.forEach((e) => {
			if (e.querySelector("input, textarea").value.length != 0) {
				if (e.parentElement.querySelector(".gfield_label")) {
					e.parentElement
						.querySelector(".gfield_label")
						.classList.add("filled");
				}
			}

			e.querySelector("input, textarea").addEventListener(
				"focus",
				() => {
					if (e.parentElement.querySelector(".gfield_label")) {
						e.parentElement
							.querySelector(".gfield_label")
							.classList.add("filled");
					}
				}
			);

			e.querySelector("input, textarea").addEventListener(
				"blur",
				() => {
					if (
						e.querySelector("input, textarea").value.length == 0
					) {
						if (
							e.parentElement.querySelector(".gfield_label")
						) {
							e.parentElement
								.querySelector(".gfield_label")
								.classList.remove("filled");
						}
					}
				}
			);
		});
	}
};

barba.hooks.beforeEnter((data) => {
	const forms = data.next.container.querySelectorAll(".gform_wrapper");
	forms.forEach((form) => {
		inputLabelAnimation(form);
	});
});

document.addEventListener("DOMContentLoaded", () => {
	const forms = document.querySelectorAll(".gform_wrapper");
	forms.forEach((form) => {
		inputLabelAnimation(form);
	});
});

jQuery(document).on("gform_post_render", function (event, form_id, current_page) {
	inputLabelAnimation(document.querySelector("#gform_" + form_id));
});
